// extracted by mini-css-extract-plugin
export default {"container":"Home_container__UI-rv","counts":"Home_counts__+uY8b","inputContainer":"Home_inputContainer__+pCKI","input":"Home_input__Znz5Q"};